import Image from "next/image";

import { InternalLink } from "@sorcery/ui";

import type { DeckPreviewType } from "~/types/deck";
import { preconPath } from "~/utils/paths";

type Props = {
  deck: DeckPreviewType;
};

export const DeckPreviewOfficial = ({ deck }: Props) => {
  return (
    <div className="duration-700 animate-in fade-in">
      <InternalLink
        href={preconPath(deck.id)}
        className="group mx-auto flex flex-col rounded-xl border border-transparent transition-all hover:border-white
          hover:shadow-[0_0_14px_rgba(255,255,255,0.75)]"
      >
        <div
          className="relative h-[180px] rounded-xl"
          style={{
            backgroundImage:
              "linear-gradient(to top, rgb(2, 2, 2) 0%, rgba(2, 2, 2, 0.9) 18%, rgba(2, 2, 2, 0.4) 35%, transparent 65%)",
          }}
        >
          {/* Backdrop */}
          <div className="absolute left-0 top-0 h-full w-full overflow-hidden rounded-xl">
            <div className="absolute left-0 top-0 h-full w-full">
              <Image
                className="scale-[1.1] rounded-xl object-cover object-[center_25%] transition-all duration-300 gradient-mask-b-60 group-hover:scale-[1.15]"
                alt={deck.name}
                fill={true}
                src={deck.feature.src}
              />
            </div>
            <div
              className="absolute h-full w-full"
              style={{
                backgroundImage: `
          linear-gradient(240deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.05) 25%),
          linear-gradient(120deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.05) 25%),
          linear-gradient(180deg, rgba(2, 2, 2, 0.3) 0%, rgba(2, 2, 2, 0.05) 25%)`,
              }}
            />
          </div>

          {/* Card */}
          <div className="flex h-full flex-col justify-end px-4 py-3">
            <div>
              <div className="mb-0 truncate text-xl font-bold text-white">{deck.name}</div>
            </div>
          </div>
        </div>
      </InternalLink>
    </div>
  );
};
